<ion-content>
  <div class="upgrade-feature-banner" *ngIf="!featureEnabled">
    <div class="flex-space-between" style="align-items: center">
      Upgrade to track email support conversations
      <ion-button
        fill="outline"
        color="light"
        class="btn-small"
        [routerLink]="'/upgrade'"
        [queryParams]="{ plan: 'startup' }"
      >
        <ion-icon name="arrow-up-circle" class="padded-icon"></ion-icon>
        Upgrade account
      </ion-button>
    </div>
  </div>

  <div class="constrained-content">
    <ion-grid>
      <ion-row>
        <ion-col size-md="5" size="12" class="settings-title-section">
          <h1><ion-icon name="globe-outline"></ion-icon>Allowed user email domains</h1>
          <p class="subtitle">
            Anyone with an email address from these domains can log into the system. Permissions still apply to limit
            access to conversation data.
          </p>
        </ion-col>
        <ion-col size-md="7" size="12">
          <div class="add-button-container flex-space-between">
            <div></div>

            <ion-button (click)="addUserEmailDomain()">
              <ion-icon name="add-outline"></ion-icon>
              <span class="text-with-left-icon hidden-sm"> Add domain </span>
            </ion-button>
          </div>
          <ion-card class="outline-card">
            <ion-list>
              <ion-item *ngFor="let eml of allowedUserEmailDomains; let i = index">
                <ion-badge color="light" class="domain-badge">
                  {{ eml }}
                </ion-badge>
                <a slot="end" (click)="deleteUserDomain(i)"> Delete </a>
              </ion-item>
            </ion-list>
          </ion-card>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col size-md="5" size="12" class="settings-title-section">
          <div class="flexed-align-center">
            <h1>
              <ion-icon name="send-outline"></ion-icon>Email sending verification
              <ion-badge
                color="warning"
                *ngIf="!emailDomains?.length || emailDomains?.[0]?.valid === false"
                style="margin: 0px 0 -5px 5px"
              >
                Not verified
              </ion-badge>
            </h1>
          </div>
          <p class="subtitle">
            Authenticate your domain to send emails on your behalf and improve deliverability. This is recommended but
            not required.
          </p>
        </ion-col>
        <ion-col size-md="7" size="12">
          <div class="add-button-container flex-space-between">
            <div></div>

            <ion-button (click)="addEmailDomain()">
              <ion-icon name="add-outline"></ion-icon>
              <span class="text-with-left-icon hidden-sm"> Add email domain </span>
            </ion-button>
          </div>
          <ion-card class="outline-card">
            <ngx-datatable
              class="material"
              columnMode="force"
              [limit]="100"
              [headerHeight]="50"
              [footerHeight]="50"
              [rowHeight]="50"
              [scrollbarH]="true"
              [rows]="emailDomains"
              [reorderable]="true"
            >
              <ngx-datatable-column name="Domain" prop="domain" [minWidth]="100">
                <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                  <ion-badge color="light" class="domain-badge">
                    {{ value }}
                  </ion-badge>
                </ng-template>
              </ngx-datatable-column>

              <ngx-datatable-column name="Valid?" prop="valid" [minWidth]="75" [maxWidth]="75">
                <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                  {{ value ? '✅' : '❌' }}
                </ng-template>
              </ngx-datatable-column>

              <ngx-datatable-column name="" prop="id" [sortable]="false" [maxWidth]="80">
                <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                  <a (click)="validateEmailDomain(row)" title="Validate"><span>Validate</span></a>
                </ng-template>
              </ngx-datatable-column>

              <ngx-datatable-column name="" prop="id" [sortable]="false" [maxWidth]="80">
                <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                  <a (click)="deleteEmailDomain(value)" title="Delete"><span>Delete</span></a>
                </ng-template>
              </ngx-datatable-column>
            </ngx-datatable>
          </ion-card>
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>
</ion-content>

<ion-modal
  [isOpen]="showValidateEmailDomainModal"
  (willDismiss)="onDismissValidateEmailDomainModal()"
  class="validate-email-domain-modal"
>
  <ng-template>
    <ion-header>
      <ion-toolbar>
        <ion-title>Validate email domain</ion-title>
        <ion-buttons slot="end">
          <ion-button (click)="onDismissValidateEmailDomainModal()"><ion-icon name="close"></ion-icon></ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content class="ion-padding">
      <ion-list class="transparent-bg" lines="none">
        <ion-item>
          <ion-label text-wrap>
            Add these entries to your DNS records to validate your domain.
            <a
              href="https://apps.google.com/supportwidget/articlehome?hl=en&article_url=https%3A%2F%2Fsupport.google.com%2Fa%2Fanswer%2F48090%3Fhl%3Den&assistant_id=generic-unu&product_context=48090&product_name=UnuFlow&trigger_context=a"
              target="_blank"
              >Learn more about DNS records.</a
            ></ion-label
          >
        </ion-item>
        <ion-item>
          <ion-checkbox [(ngModel)]="excludeDomainFromHost"></ion-checkbox>
          <ion-label> Using Namecheap as a hosting service? </ion-label>
        </ion-item>
      </ion-list>
      <ion-card class="outline-card">
        <ngx-datatable
          class="material"
          columnMode="force"
          [limit]="100"
          [headerHeight]="50"
          [footerHeight]="false"
          [rowHeight]="50"
          [scrollbarH]="true"
          [rows]="dnsValidation"
          [reorderable]="false"
        >
          <ngx-datatable-column name="Valid?" prop="valid" [minWidth]="75" [maxWidth]="75" [sortable]="false">
            <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
              {{ value ? '✅' : '❌' }}
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="Type" prop="type" [sortable]="false" [minWidth]="125" [maxWidth]="125">
            <ng-template let-value="value" let-row="row" ngx-datatable-cell-template> CNAME </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="Host" prop="host" [sortable]="false">
            <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
              {{ getHostDisplayValue(value) }}
              <a
                ngxTippy
                data-tippy-content="Copy to clipboard"
                (click)="copyValidationToClipboard(getHostDisplayValue(value))"
              >
                <ion-icon name="copy-outline" style="margin-left: 12px"></ion-icon>
              </a>
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="Value" prop="data" [sortable]="false">
            <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
              {{ value }}
              <a ngxTippy data-tippy-content="Copy to clipboard" (click)="copyValidationToClipboard(value)">
                <ion-icon name="copy-outline" style="margin-left: 12px"></ion-icon>
              </a>
            </ng-template>
          </ngx-datatable-column>
        </ngx-datatable>
      </ion-card>
      <div style="padding: 12px">
        <strong>Recommended: </strong>Update your SPF record to include <span class="code">sendgrid.net</span> as a
        valid sender.
      </div>
      <ion-button (click)="submitEmailDomainValidation()" style="margin: 15px 10px">Check validation</ion-button>
    </ion-content>
  </ng-template>
</ion-modal>
